import { Paragraph } from '@eggplant/pattern-library'

const NotificationDefaultPortDescription = () =>
  <Paragraph>
    Default port is 25
  </Paragraph>

export default NotificationDefaultPortDescription
